module.exports = __webpack_public_path__ + "07_long_beige.8ed664c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_long_beige.png
// module id = nS7W
// module chunks = 0